import { render } from "./CreateVolunteer.vue?vue&type=template&id=a3a6c2cc&scoped=true"
import script from "./CreateVolunteer.vue?vue&type=script&lang=js"
export * from "./CreateVolunteer.vue?vue&type=script&lang=js"

import "./CreateVolunteer.vue?vue&type=style&index=0&id=a3a6c2cc&scoped=true&lang=css"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3a6c2cc"]])

export default __exports__